// import styles from './Header.module.css';
// import logo from '../../logo.svg';
import { useContext } from 'react';
import VideoContext from '../../store/video-context';
import { Navbar, Nav, NavDropdown } from 'react-bootstrap';

const Header = (props: any) => {
  const vContext = useContext(VideoContext);
  const isAdmin = props.isAdmin;
  return (
    <>
      <div className="fixed-top navbar-dark main-menu">
        <div className="container">
          <Navbar expand="lg" className="py-0 align-items-end">

            <a className="navbar-brand" href="../lapguru.php">
              {/* <img src="../style/images/lapguru/lapguru_logo.png" alt="LapGuru" title="LapGuru" /> */}
              <img src={"../"+vContext.videoData.header_logo_img} alt="Logo"  />
              </a>
            <Navbar.Toggle aria-controls="basic-navbar-nav"><span className="navbar-toggler-icon"></span></Navbar.Toggle>
            <Navbar.Collapse id="basic-navbar-nav" className="align-items-end">
              <ul className="navbar-nav mr-auto">
                <li className="nav-item">
                  <a className="nav-link" target="_blank" href="../lapguru.php">Home <span className="sr-only">(current)</span></a>
                </li>
                <li className="nav-item">
                  <a className="nav-link" target="_blank" href="../ondemandSearch/viewRecordedSurgery.php">Recorded Events</a>
                </li>
                <li className="nav-item">
                  <a className="nav-link" target="_blank" href="../cmeworkshop/cmeworkshop.php">CME Events</a>
                </li>
                <li className="nav-item">
                  <a className="nav-link" target="_blank" href="../MembershipPlans/planPrice.php">Pricing</a>
                </li>
                <li className="nav-item">
                  <a className="nav-link" target="_blank" href="http://blog.lapguru.com/">Blog</a>
                </li>
              </ul>
              <div className="navbar-form navbar-right pb-3">
                <div className="form-group">
                  <div style={{ float: 'left' }}>
                    <div className="white_username_txtHeader">
                      {/* Dr. Guest Viewer 8 */}
                      {vContext.userData.full_name}
                    </div>
                    <div >
                      {/* align="right" */}
                      <a href="javascript:void(0)" onClick={() => { window.open(window.location.origin + '/MembershipPlans/myAccount.php') }} className="logout">My Account</a>
                    </div>
                  </div>
                  <div style={{ float: 'left', paddingLeft: '10px' }}>
                    {/* <img src="../style/images/commonspeciality/dr_photos/profile_img_321.png" alt="" width="28" height="28" style={{ border: '1px solid #1b87c9' }} /> */}
                 {
                  vContext.userData.user_photo !== ''? 
                  <img src={window.location.origin + "/" + vContext.userData.user_photo} alt="" className="header-profile-img"/>
                  : 
                  <div className="header-initial d-flex justify-content-center align-items-center">
                    {/* {vContext.userData.full_name.split(' ').map((name:any) => name[0]).join('').toUpperCase()} */}
                    {vContext.userData.profile_name}
                  </div>
                }
                  </div>
                </div>
              </div>
            </Navbar.Collapse>
          </Navbar>
        </div>
      </div>
    </>
  )
}

export default Header;
